import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class Part extends Base {
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */

  getOne(id) {
    const url = this._getFullURL("/cmms/parts/" + id);
    return this._secureFetch(url);
  }

  update(id, payload, photoFile, attachments) {
    const url = this._getFullURL("/cmms/parts/" + id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var formdata = new FormData();
    formdata.append("filePhoto", photoFile);
    const metadata = [];
    const newAttachments = {};
    if (!attachments) attachments = [];
    attachments.forEach((item, index) => {
      // You can give each file a custom field name like `files[]` or `file_0`
      if (!item.exist) {
        formdata.append("file_" + index, item.file); // backend must accept array uploads
        metadata.push({
          field: "file_" + index,
          name: item.name,
          type: item.type,
        });
      } else {
        newAttachments[item.origin_key] = item.value;
      }
    });
    if (Object.keys(newAttachments).length > 0)
      formdata.append("attachments", JSON.stringify(newAttachments));
    if (metadata.length > 0)
      formdata.append("metadata", JSON.stringify(metadata));
    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  delete(id) {
    const url = this._getFullURL("/cmms/parts/" + id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);

    var requestOptions = {
      method: "DELETE",
      headers: myHeaders,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  list(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/cmms/parts?" + queryParam);
    return this._secureFetch(url);
  }
  create(payload, photoFile, attachments) {
    const url = this._getFullURL("/cmms/parts");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${getAccessToken()}`);
    var formdata = new FormData();
    if (photoFile) formdata.append("filePhoto", photoFile);
    const metadata = [];
    attachments.forEach((item, index) => {
      // You can give each file a custom field name like `files[]` or `file_0`
      formdata.append("file_" + index, item.file); // backend must accept array uploads
      metadata.push({
        field: "file_" + index,
        name: item.name,
        type: item.type,
      });
    });
    if (metadata.length > 0)
      formdata.append("metadata", JSON.stringify(metadata));

    Object.keys(payload).map((z) => {
      formdata.append(z, payload[z]);
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };
    return fetch(url, requestOptions);
  }

  import(payload) {
    const url = this._getFullURL("/cmms/parts/import");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
}
